// Image types doc: https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types

export const imageAPngMimeType = 'image/apng';
export const imageBmpMimeType = 'image/bmp';
export const imageGifMimeType = 'image/gif';
export const imageJpegMimeType = 'image/jpeg';
export const imagePJpegMimeType = 'image/pjpeg';
export const imagePngMimeType = 'image/png';
export const imageSvgMimeType = 'image/svg+xml';
export const imageTiffMimeType = 'image/tiff';
export const imageWebpMimeType = 'image/webp';
export const imageIconMimeType = 'image/x-icon';
